import { OutlinedInput } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 140,
    maxWidth: 300
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing.unit / 4
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder"
];

function getStyles(name, selectedOptions, that) {
  return {
    fontWeight:
      selectedOptions.indexOf(name) === -1
        ? that.props.theme.typography.fontWeightRegular
        : that.props.theme.typography.fontWeightMedium
  };
}

function getNameArrayFromSelectedOption(options) {}

class MultipleSelect extends React.Component {
  render() {
    const { classes, options, handleChange, selectedOptions } = this.props;
    return (
      <div className={classes.root}>
        <label htmlFor={this.id}>Commodity Variety</label>

        <FormControl
          className={classNames(classes.formControl, classes.noLabel)}
          style={{
            marginTop: "4px",
            width: "100%",
            marginLeft: "0px",
            marginRight: "0px"
          }}
        >
          <Select
            multiple
            displayEmpty
            value={selectedOptions}
            onChange={(event, child) =>
              handleChange({ event, child, fieldName: "comodityVariety" })
            }
            input={<OutlinedInput id="select-multiple-placeholder" />}
            renderValue={selected => {
              if (selected.length === 0) {
                return <em>Select</em>;
              }

              return selected.join(", ");
            }}
            MenuProps={MenuProps}
          >
            <MenuItem disabled value="">
              <em>Select</em>
            </MenuItem>
            {options &&
              options.map(option => (
                <MenuItem
                  key={option}
                  value={option.name}
                  name={option}
                  style={getStyles(option.name, selectedOptions, this)}
                >
                  {option.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

MultipleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(MultipleSelect);



// WEBPACK FOOTER //
// ./src/components/FormElement/MultipleSelect.js